/* eslint-disable */

// react imports
import { useEffect } from "react";

// @mui imports
import Card from "@mui/material/Card";

// react router imports
// import { useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";

// Data
import data from "layouts/orders/components/Projects/data";

// Context import
import { useMaterialUIController } from "context";

// ExcelJS import
import * as excelJS from "exceljs";
import { saveAs } from "file-saver";

function Projects() {
  const [controller] = useMaterialUIController();
  const { currentStudy } = controller;
  // const navigate = useNavigate();
  const { columns, rows, XLSX, custom, chosen } = data();

  useEffect(() => {
    console.log("CUSTOM >>>", custom);
  }, [custom]);

  useEffect(() => {
    console.log("CHOSEN >>>", chosen);
  }, [chosen]);

  // Exceljs functions
  function exportPrint() {
    // Exceljs Start
    const workbook = new excelJS.Workbook();
    workbook.creator = "test";
    workbook.lastModifiedBy = "test";
    workbook.created = new Date();
    workbook.modified = new Date();

    const sheet = workbook.addWorksheet(`print_totals_${currentStudy}`);

    // Styles
    const thinBorder = {
      top: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } },
    };

    const blueFill = {
      type: "pattern",
      pattern: "darkTrellis",
      fgColor: { argb: "ddebf7" },
      bgColor: { argb: "ddebf7" },
    };

    let headingName = "SYNH/IMVT 1401-3101 FLEX";
    if (XLSX.length > 0) {
      const studyId = XLSX[0].toolName.split("IMVT-")[1].split("_")[0];
      if (studyId) {
        headingName = `SYNH/IMVT ${studyId} ${currentStudy.replace("_STUDY", "")}`;
      }
    }

    // 添加表头
    sheet.getRow(1).values = [headingName, "", , , , "PRINTER HERE"];
    sheet.getRow(2).values = [
      "TOOL NAME",
      "DESCRIPTION",
      "SITES",
      "PER SITE",
      "TOTAL \nQTY",
      "PER \nUNIT",
      "TOTAL",
    ];

    // 添加数据项定义，与之前不同的是，此时去除header字段
    sheet.columns = [
      { key: "toolName", width: 50 },
      { key: "desc", width: 30 },
      { key: "sites", width: 10 },
      { key: "perSite", width: 10 },
      { key: "qty", width: 10 },
      { key: "perUnit", width: 10 },
      { key: "total", width: 10 },
    ];

    const cellData = XLSX;

    cellData.forEach((row, i) => {
      row.desc = row.desc.trim();
    });

    sheet.addRows(cellData);


    // 合并单元格
    sheet.mergeCells(`A1:E1`);
    sheet.mergeCells("F1:G1");
    // sheet.mergeCells("A1:A2");

    // 设置每一列样式
    const row = sheet.getRow(1);
    row.eachCell((cell, rowNumber) => {
      sheet.getColumn(rowNumber).alignment = {
        vertical: "bottom",
        horizontal: "left",
      };
      sheet.getColumn(rowNumber).font = { size: 14, family: 2 };
    });

    // Fills
    sheet.getCell("A1").fill = blueFill;
    sheet.getCell("F1").fill = blueFill;
    sheet.getCell("A2").fill = blueFill;
    sheet.getCell("B2").fill = blueFill;
    sheet.getCell("C2").fill = blueFill;
    sheet.getCell("D2").fill = blueFill;
    sheet.getCell("E2").fill = blueFill;
    sheet.getCell("F2").fill = blueFill;
    sheet.getCell("G2").fill = blueFill;

    // Borders
    sheet.getCell("A1").border = thinBorder;
    sheet.getCell("F1").border = thinBorder;
    sheet.getCell("A2").border = thinBorder;
    sheet.getCell("B2").border = thinBorder;
    sheet.getCell("C2").border = thinBorder;
    sheet.getCell("D2").border = thinBorder;
    sheet.getCell("E2").border = thinBorder;
    sheet.getCell("F2").border = thinBorder;
    sheet.getCell("G2").border = thinBorder;
    // Exceljs end

    workbook.xlsx.writeBuffer().then((buffer) => {
      const today = new Date().toLocaleDateString();

      const blob = new Blob([buffer], { type: "applicationi/xlsx" });
      saveAs(blob, `print_totals_${currentStudy}_${today}.xlsx`);
    });
  }

  function exportCustomization() {
    // Exceljs Start
    const workbook = new excelJS.Workbook();
    workbook.creator = "test";
    workbook.lastModifiedBy = "test";
    workbook.created = new Date();
    workbook.modified = new Date();

    const sheet = workbook.addWorksheet(`customization_${currentStudy}`);

    // Styles
    const greenFill = {
      type: "pattern",
      pattern: "darkTrellis",
      fgColor: { argb: "ecf1e0" },
      bgColor: { argb: "ecf1e0" },
    };

    // 添加表头
    sheet.getRow(1).values = ["SITE CONTACT INFORMATION SECTION"];
    sheet.getRow(2).values = [
      "SITE #",
      "Customization Line 1",
      "Customization Line 2",
      "Customization Line 3",
      "Order #",
      "Street Address",
      "City",
      "State",
      "Zip",
    ];

    // header
    sheet.columns = [
      { key: "siteNumb", width: 10 },
      { key: "line1", width: 30 },
      { key: "line2", width: 30 },
      { key: "line3", width: 30 },
      { key: "orderId", width: 10 },
      { key: "street", width: 10 },
      { key: "city", width: 10 },
      { key: "state", width: 10 },
      { key: "zip", width: 10 },
    ];

    const cellData = custom;
    sheet.addRows(cellData);

    // Merge cells
    sheet.mergeCells(`A1:Z1`);

    // Column coloring
    // const row = sheet.getRow(2);
    // row.eachCell((cell, rowNumber) => {
    //   sheet.getColumn(rowNumber).alignment = {
    //     vertical: "bottom",
    //     horizontal: "left",
    //   };
    //   sheet.getColumn(rowNumber).font = { size: 14, family: 2 };
    //   sheet.getColumn(rowNumber).fill = blueFill;
    // });
    // Exceljs end

    sheet.getColumn(2).fill = greenFill;
    sheet.getColumn(3).fill = greenFill;
    sheet.getColumn(4).fill = greenFill;

    workbook.xlsx.writeBuffer().then((buffer) => {
      const today = new Date().toLocaleDateString();

      const blob = new Blob([buffer], { type: "applicationi/xlsx" });
      saveAs(blob, `customization_${currentStudy}_${today}.xlsx`);
    });
  }

  return (
    <Card>
      <MDBox px={2}>
        {/* <MDBox p={2}>
          <MDButton
            onClick={() => {
              console.log(XLSX);
            }}
          >
            Rows Log
          </MDButton>
        </MDBox> */}
        <MDButton
          variant="gradient"
          color="info"
          size="small"
          sx={{ marginLeft: "1rem" }}
          style={{
            opacity: chosen.length === 0 && "0.6",
            cursor: chosen.length === 0 && "default",
            pointerEvents: chosen.length === 0 && "none",
          }}
          onClick={() => {
            if (chosen.length > 0) {
              exportPrint();
              if (custom.length > 0) {
                exportCustomization();
              }
            }
          }}
        >
          export Excel
        </MDButton>
      </MDBox>
      <MDBox>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted
          noEndBorder
          entriesPerPage
          canSearch
        />
      </MDBox>
    </Card>
  );
}

export default Projects;
